export const PRODUCT_TYPE_INFO = 'PRODUCT_TYPE_INFO';

export const getProductTypeInfo = () => dispatch => {
  if (!window.XM_getProductTypeInfo) {
    return;
  }

  try {
    dispatch({
      type: PRODUCT_TYPE_INFO,
      payload: window.XM_getProductTypeInfo(),
    });
  } catch (err) {
    // cannot do anything about this non-fatal failure
    // catch so that it doesn't stop js exec further down
  }
};
